import { CHANGES_MADE, RESET_CHANGES } from './types';

export const configurationChanged = (): {
  type: string;
} => ({
  type: CHANGES_MADE,
});

export const configurationSaved = (): {
  type: string;
} => ({
  type: RESET_CHANGES,
});
